export enum DIRECTION {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL',
  DEFAULT = 'DEFAULT',
}

export enum STATUS {
  NORMAL = 'NORMAL',
  PULLING = 'PULLING',
  LOOSING = 'LOOSING',
  SUCCESS = 'SUCCESS',
  LOADING = 'LOADING',
}
